import { render } from "./App.vue?vue&type=template&id=e345c23a&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e345c23a&lang=sass"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__